import { Image, Switch } from 'antd';
import React from 'react';

const tableConfig = (props) => (
	{
		columns: [
			{
				title: 'Banner Name', field: 'name', filterAndSearch: false, width: "150px",
			},
			{
				title: 'Banner Image', field: 'banner_url', filterAndSearch: false, width: "150px",
				render: rowData => <div>
					<Image
						width={200}
						preview={false}
						src={rowData.banner_url} />
				</div>
			},
			{
				title: 'Banner Description', field: 'description', filterAndSearch: false, width: "150px",
			},
			{
				title: 'Banner Order', field: 'sort_order_by', filterAndSearch: false, width: "150px",
			},
			{
				title: 'Banner status', field: 'status', filterAndSearch: false, width: "150px",
				render: rowData => <div><Switch checked={rowData.status || false} /></div >
			},
		],
	}
)

export default tableConfig;
